import { Theme, createTheme } from '@mui/material';

export const createDialogTheme = (currTheme: Theme): Theme => {
  const theme = createTheme(currTheme, {
    components: {
      MuiDialog: {
        styleOverrides: {
          paper: `
            border-radius: 8px;
            min-width: 32rem;
            max-width: 64rem
          `
        }
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            ...currTheme.typography.h2,
            color: currTheme.palette.common.white,
            backgroundColor: currTheme.palette.primary.main,
            margin: 0,
            padding: '1.5rem 2rem',
            textAlign: 'center'
          }
        },
        defaultProps: {
          component: 'h1'
        }
      },
      MuiDialogContent: {
        defaultProps: {
          dividers: true
        },
        styleOverrides: {
          root: `
            padding: 2.5rem;
            border-top: 0;
            border-bottom: 0;
          `
        }
      },
      MuiDialogContentText: {
        styleOverrides: {
          root: currTheme.typography.body
        }
      },
      MuiDialogActions: {
        styleOverrides: {
          root: `
            & > :not(:first-of-type) {
              margin-left: 1.5rem;
            }
            justify-content: flex-start;
            padding: 1.5rem 2.5rem;
            background: #F8F8FA;
          `
        }
      }
    }
  });

  return theme;
};
